export const NOTICE_MS = 10_000;
export const ROUTINE_NOTE_CLEAR_HANDOFF_MS = 60_000;
